import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2CustomerAccept = hashCodeCertificate("WaybillV2CustomerAccept")

export default WaybillV2CustomerAccept
